import { createContext } from 'react'

export type ArticleBodyContentContextType = true

const ArticleBodyContentContext = createContext<
  ArticleBodyContentContextType | undefined
>(undefined)

export default ArticleBodyContentContext
